import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaCheck } from 'react-icons/fa';
import { FaRegCalendarAlt, FaRegClock, FaRegMap } from 'react-icons/fa';
import EventDetailsModal from './EventDetailsModal';
import CostsModal from './CostsModal';

const CeremonyAndParty = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCostsModalOpen, setIsCostsModalOpen] = useState(false);

  return (
    <section className="min-h-screen py-20 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-4xl mx-auto text-center"
      >
        <h2 className="text-4xl md:text-5xl font-cursive text-gray-800 mb-16">
          ¡Te esperamos!
        </h2>

        {/* Fecha y Hora */}
        <div className="mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex flex-col items-center gap-6"
          >
            <div className="relative">
              <FaRegCalendarAlt className="text-5xl text-[#D4AF37]" />
              <div className="absolute -top-2 -right-2 w-4 h-4 bg-pink-200 rounded-full animate-pulse" />
            </div>

            <div className="rounded-xl p-6 shadow-md">
              <div className="space-y-6">
                <div className="border-b border-pink-200 pb-4">
                  <p className="text-2xl font-serif text-gray-700">Sábado 29 de Noviembre</p>
                  <div className="flex items-center justify-center gap-2 mt-2">
                    <FaRegClock className="text-[#D4AF37]" />
                    <p className="text-xl font-serif text-gray-600">A partir de las 19:00 hs</p>
                  </div>
                </div>
                <div>
                  <p className="text-2xl font-serif text-gray-700">Domingo 30 de Noviembre</p>
                  <div className="flex items-center justify-center gap-2 mt-2">
                    <p className="text-xl font-serif text-gray-600">Continuamos la celebración</p>
                  </div>
                  <div className="flex items-center justify-center gap-2 mt-2">
                    <FaRegClock className="text-[#D4AF37]" />
                    <p className="text-xl font-serif text-gray-600">A partir de las 12:00 hs</p>
                  </div>
                </div>
              </div>
              <div className="mt-6 flex flex-col items-center gap-3">
                <button
                  onClick={() => {
                    const event = {
                      text: 'Casamiento Jime & Pablo',
                      dates: '20251129T190000/20251130T230000',
                      details: 'Día 1: Fiesta principal - Día 2: Asado y pileta',
                      location: 'Nawan Mountain Resort, Sinsacate, Córdoba',
                    };

                    const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.text)}&dates=${event.dates}&details=${encodeURIComponent(event.details)}&location=${encodeURIComponent(event.location)}`;

                    window.open(googleCalendarUrl, '_blank');
                  }}
                  className="bg-[#D4AF37] text-white px-6 py-2 rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-md flex items-center gap-2 border-2 border-[#FFD700] hover:border-[#D4AF37] font-cursive"
                >
                  <FaRegCalendarAlt className="text-sm" />
                  <span>Agendar evento</span>
                </button>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="text-[#D4AF37] hover:text-[#C5A028] transition-colors duration-300 flex items-center gap-2 font-serif"
                >
                  <span className="border-b border-pink-300">Ver más detalles</span>
                </button>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Lugar y Dirección */}
        <div className="flex flex-col items-center gap-12 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="flex flex-col items-center gap-6 w-full max-w-md"
          >
            <FaRegMap className="text-5xl text-[#D4AF37]" />
            <div className="text-center">
              <button
                className="bg-[#D4AF37] text-white text-xl px-8 py-3 rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-md border-2 border-[#FFD700] hover:border-[#D4AF37] hover:shadow-lg active:shadow-inner font-cursive"
                style={{ boxShadow: 'inset 0 2px 4px 0 rgba(255, 255, 255, 0.3)' }}
                onClick={() => window.open('https://maps.google.com/?q=Nawan+Mountain+Resort', '_blank')}
              >
                Nawan Mountain Resort
              </button>
              <p className="text-sm text-gray-600 mt-2 font-serif">Sinsacate, Córdoba</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6 }}
            className="w-full max-w-md flex justify-center"
          >
            <div className="relative w-full flex flex-col items-center">
              <motion.div
                className="absolute inset-0 bg-[#D4AF37] opacity-20 rounded-full blur-xl"
                animate={{
                  scale: [1, 1.1, 1],
                  opacity: [0.2, 0.3, 0.2]
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
              <FaCheck className="text-5xl text-[#D4AF37] mb-4" />
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="relative z-10 bg-[#D4AF37] text-white px-16 py-5 text-xl rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-lg border-2 border-[#FFD700] hover:border-[#D4AF37] font-cursive"
                onClick={() => setIsCostsModalOpen(true)}
              >
                Confirmar asistencia
              </motion.button>
              <p className="mt-3 text-sm text-gray-600 italic font-serif">
                Por favor confirmar antes del 1 de octubre de 2025
              </p>
            </div>
          </motion.div>
        </div>

        <EventDetailsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />

        <CostsModal
          isOpen={isCostsModalOpen}
          onClose={() => setIsCostsModalOpen(false)}
        />
      </motion.div>
    </section>
  );
};

export default CeremonyAndParty; 